import { useEffect, useState } from "react";

export const SuccessMessage = ({ message = "Action successful!", onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  return (
    <div className="success-message2">
      <div className="success-content">
        <span className="success-icon">✓</span>
        <span className="success-text">{message}</span>
        <button
          className="success-close"
          onClick={() => {
            setVisible(false);
            onClose?.();
          }}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};